/**
 * A friendlier error that still carries the server's answer.
 *
 * Services often replace a failed request with a message a person can read.
 * Throwing a bare `new Error(message)` drops `response`, so screens can no
 * longer tell "not found" from "not allowed" from a crash (row 125's
 * RecordLoadProblem reads the status). This keeps the SAME message and adds the
 * original's `response`, `status` and the original error as `cause`.
 *
 * `utils/errorMessages.js` recognises the shape (`cause.response === response`)
 * and shows this message rather than the raw body.
 *
 * Rows 127 (crmService) and 128 (the remaining services).
 */
const keepServerAnswer = (original, message) => {
    const error = new Error(message);
    error.response = original?.response;
    error.status = original?.response?.status;
    error.cause = original;
    return error;
};

export default keepServerAnswer;
